module.exports = __webpack_public_path__ + "img/progress-arrow.eb01f21e.svg";